module.exports = __webpack_public_path__ + "static/img/NORTH-MELBOURNE.5cb2247.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NORTH-MELBOURNE.svg
// module id = j9i6
// module chunks = 0